export let dto_common = {
  CSP: String,
  NatvieCountry: String,
  MemmoryURl: String,
  SCHEDULEDDATE: String,
  SCHEDULEDTIME: String,
  ZoneId: Number,
  ZoneDescription: String,
  DineType: Number,
  DefaultImageUrl: String,
  DeliveryZoneID: Number,
  CurrentCordinate: String,
  MobileCordinate: String,
  PicupCordinate: String,
  MTYPE: String,
  HeaderTabName: String,
  PromoGuid: Number,
  DiscPercentage: String,
  DiscAmount: Number,
  IsCash: Number,
};
